module.exports = __webpack_public_path__ + "public/images/about-4.482d89178b6a703e91c1843ea87fd7b0.png";